import React from 'react';

const TwitterIcon: React.FC = () => (
  <svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30 3.625C28.875 4.1875 27.75 4.375 26.4375 4.5625C27.75 3.8125 28.6875 2.6875 29.0625 1.1875C27.9375 1.9375 26.625 2.3125 25.125 2.6875C24 1.5625 22.3125 0.8125 20.625 0.8125C16.6875 0.8125 13.6875 4.5625 14.625 8.3125C9.5625 8.125 5.0625 5.6875 1.875 1.9375C0.1875 4.75 1.125 8.3125 3.75 10.1875C2.8125 10.1875 1.875 9.8125 0.9375 9.4375C0.9375 12.25 3 14.875 5.8125 15.625C4.875 15.8125 3.9375 16 3 15.8125C3.75 18.25 6 20.125 8.8125 20.125C6.5625 21.8125 3.1875 22.75 0 22.375C2.8125 24.0625 6 25.1875 9.375 25.1875C20.8125 25.1875 27.1875 15.625 26.8125 6.8125C28.125 6.0625 29.25 4.9375 30 3.625Z"
      fill="white"
    />
  </svg>
);

export default TwitterIcon;
